// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const hetu: CountryValidator<"FI", ParsedPersonId> =
  createValidator("fi.hetu", 71);

export default hetu;
export const compact = hetu.compact;
export const format = hetu.format;
export const validate = hetu.validate;
export const generate = (): string =>
  hetu.generate?.() ??
  (() => {
    throw new Error(
      "Validator fi.hetu cannot generate values",
    );
  })();
export const parse = hetu.parse;
